import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import moment from 'moment'

import Select from '../form/Select'
import Date from '../form/Date'
import Badge from '../../UniformComponents/Badge'
import Switch from '../../UniformComponents/Switch'
import Button from '../../UniformComponents/Button'
import Input from '../form/Input'
import HoverInfo from '../../UniformComponents/HoverInfo'
import Checkbox from '../form/Checkbox'
import TemplateAccess from '../TemplateAccess'
import TemplateCustomTags from '../TemplateCustomTags'
import RadioGroup from '../form/RadioGroup'

@observer
class SettingsForm extends Component {
    constructor(props) {
        super(props)
        this.formField = this.props
    }

    register = (name, validate, path) => {
        const { formFields } = this.props
        if (path) {
            formFields[name] = {
                validate,
                path,
            }
            return
        }
        formFields[name] = validate
    }

    unregister = (name) => {
        const { formFields } = this.props
        Reflect.deleteProperty(formFields, name)
    }

    renderFields = (store, formFields) => {
        return formFields.map((field) => {
            if (field && !field.show) return null
            switch (field.type) {
                case 'radioGroup': {
                    return (
                        <RadioGroup
                            onBlur={(val) => field.onChange(val, val)}
                            defaultChecked={field.defaultChecked}
                            options={field.options}
                            refreshOnRender
                        />
                    )
                }
                case 'select': {
                    return (
                        <Select
                            register={this.register}
                            unregister={this.unregister}
                            name={field.name}
                            label={field.label}
                            options={field.options}
                            defaultValue={field.value}
                            value={field.value}
                            onBlur={field.onChange}
                            placeholder={field.placeholder || i18n.t('form.select.placeholder')}
                            isMandatory={field.isMandatory || false}
                            emptyError={`${field.label} ${i18n.t('required')}`}
                            cssClass={field.cssClass || ''}
                            showDisabled={field.disabled || false}
                            lockedDropdown={field.lockedDropdown || false}
                            isMulti={field.isMulti || false}
                            openMenuOnClick={field.openMenuOnClick}
                        />
                    )
                }
                case 'input': {
                    return (
                        <Input
                            type={field.inputType || 'text'}
                            register={this.register}
                            unregister={this.unregister}
                            defaultValue={field.defaultValue}
                            value={field.value}
                            onBlur={field.onBlur}
                            placeholder={field.placeholder || i18n.t('form.input.placeholder')}
                            label={field.label}
                            cssClass={field.cssClass}
                            name={field.name}
                            isMandatory={field.isMandatory}
                            emptyError={`${field.label} ${i18n.t('required')}`}
                            disabled={field.allowEdit}
                            onChange={field.onChange}
                            onEdit={field.hanldeAllowEdit}
                        />
                    )
                }
                case 'custom': {
                    return (
                        <div className="sub-wrapper">
                            <strong className="no-wrap">{field.label}</strong>
                            <Badge
                                cssClass="settings-badge"
                                type={field.style || 'success'}
                                label={field.bannerLabel}
                                icon={field.icon}
                            />
                        </div>
                    )
                }
                case 'date': {
                    return (
                        <div className={field.compName}>
                            <Date
                                name={field.name}
                                label={field.label}
                                placeholder={field.placeholder || i18n.t('form.date.placeholder')}
                                isMandatory={field.isMandatory}
                                value={moment(field.value).tz(store.store.timeZone)}
                                minDate={field.minDate}
                                maxDate={field.maxDate}
                                emptyError={`${field.label} ${i18n.t('required')}`}
                                onBlur={field.onBlur}
                                register={this.register}
                                unregister={this.unregister}
                                disabled={field.disabled}
                                calendarCss={field.calendarCss}
                                allowManualDateEdit={field.allowManualDateEdit}
                                dateFormat={field.dateFormat}
                            />
                        </div>
                    )
                }
                case 'time': {
                    return (
                        <div className={field.compName}>
                            <Date
                                name={field.name}
                                label={field.label}
                                placeholder={field.placeholder || i18n.t('form.date.placeholder')}
                                isMandatory={field.isMandatory}
                                value={moment(field.value).tz(store.store.timeZone)}
                                emptyError={`${field.label} ${i18n.t('required')}`}
                                showTimeSelectOnly
                                showTimeSelect
                                dateFormat="HH:mm z"
                                useGMT={false}
                                calendarCss={`timeOnlyFeild ${field.calendarCss}`}
                                onBlur={field.onBlur}
                                register={this.register}
                                unregister={this.unregister}
                                disabled={field.disabled}
                            />
                        </div>
                    )
                }
                case 'flexFields': {
                    return (
                        <div className={`flexRow ${field.compName}`}>
                            {this.renderFields(store, field.components)}
                        </div>

                    )
                }
                case 'switch': {
                    return (
                        <div className="settings-wrapper settings-switch">

                            <label htmlFor="select " className="switch-container-label">
                                {field.label}
                                <HoverInfo
                                    cssClass="hover-info"
                                    title={field.tooltipTitle}
                                    desc={field.tooltipText}
                                    linkText={field.tooltipLinkLabel}
                                    href={field.tooltipLink}
                                    dir="right"
                                >
                                    <i className="info-icon fa-solid fa-circle-question" />
                                </HoverInfo>

                            </label>
                            <div className="inner-content">
                                <p className={field.disabled ? 'disabled' : ''}>{field.text}</p>
                                <Switch
                                    onToggle={field.toggleSwitch}
                                    label={!field.state ? 'Yes' : 'No'}
                                    isLeft
                                    state={field.state}
                                    icon="fa-regular fa-check"
                                    disabled={field.disabled}
                                />
                            </div>

                        </div>
                    )
                }
                case 'button': {
                    return (
                        <Button
                            name={field.name}
                            label={field.label}
                            cssClass={field.cssClass}
                            icon={field.icon}
                            onClick={field.handleClick}
                        />
                    )
                }
                case 'checkbox': {
                    return (
                        <Checkbox
                            defaultChecked={field.defaultChecked}
                            checked={field.checked}
                            onBlur={field.onChange}
                            name={field.name}
                            label={field.label}
                            register={this.register}
                            unregister={this.unregister}
                            labelDir="right"
                            disabled={field.disabled}
                        />
                    )
                }
                case 'dynamicComponentSets': {
                    return (
                        <div className={field.style || ''}>
                            {field.topic ? <p className={field.topicCssClass}>{field.topic}</p> : null}
                            <div className="checkbox-wrapper">
                                {this.renderFields(store, field.components)}
                            </div>
                        </div>

                    )
                }
                case 'templateAccessAccordion': {
                    return <TemplateAccess fieldConfig={field} store={store.store} />
                }
                case 'templateCustomTags': {
                    return <TemplateCustomTags templateParams={field.templateParams} appStore={store.store} />
                }
                default:
                    return field
            }
        })
    }

    render() {
        const { store, formFields } = this.props
        return (
            <div className="field-wrapper">
                {this.renderFields(store, formFields)}
            </div>
        )
    }
}

export default SettingsForm
